export default __webpack_public_path__ + "static/media/safe7-intro-bn.a78e854c.png";